import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
// @src imports
import AddressForm, {
  FormContact,
} from 'src/contacts/components/AddressForm/AddressForm'

interface Props {
  isSavingAddress?: boolean
  shippingAddress: FormContact // TODO: Update this when photo-manager is merged
  isAddressVisible: boolean
  onCountryChange: (country: string) => void
  onStateChange: (state: string) => void
  onShippingAddressChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSubmitAddress: () => void
}

const ShippingAddress: React.FC<Props> = props => {
  const {
    isSavingAddress,
    shippingAddress,
    isAddressVisible,
    onCountryChange,
    onStateChange,
    onShippingAddressChange,
    onSubmitAddress,
  } = props
  const {
    address1,
    address2,
    firstName,
    lastName,
    city,
    state,
    postalCode,
  } = shippingAddress
  return (
    <div>
      {isAddressVisible && (
        <AddressForm
          contact={shippingAddress}
          onChange={onShippingAddressChange}
          onCountryChange={onCountryChange}
          onStateChange={onStateChange}
          shouldShowDates={false}
          isTitleVisible={false}
          isSaving={isSavingAddress}
          onSubmit={onSubmitAddress}
          style={{
            paddingRight: 30,
          }}
        />
      )}
      {!isAddressVisible &&
        (address1 ? (
          <div>
            <Text type="caption">{`${firstName} ${lastName}`}</Text>
            <Text type="caption">{`${address1}`}</Text>
            <Text type="caption">{`${address2}`}</Text>
            <Text type="caption">{`${city} ${state}, ${postalCode}`}</Text>
          </div>
        ) : (
          <Text type="caption">No return address set</Text>
        ))}
    </div>
  )
}

export default ShippingAddress
